import React from "react";

const InvoiceSelectionTable = ({
  invoices,
  selectedInvoiceIds,
  onToggleAll,
  onToggleInvoice,
  amountHeaderLabel,
}) => {
  const selectableInvoices = invoices.filter((invoice) => Number(invoice.amount) > 0);
  const allSelected =
    selectableInvoices.length > 0 &&
    selectableInvoices.every((invoice) =>
      selectedInvoiceIds.includes(invoice.selectionKey)
    );

  return (
    <div className="invoice-selection-table">
      <div className="table-responsive">
        <table className="table table-sm mb-0">
          <thead>
            <tr>
              <th style={{ width: 48 }}>
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={(event) => onToggleAll(event.target.checked)}
                  disabled={selectableInvoices.length === 0}
                />
              </th>
              <th>Invoice No.</th>
              <th>Description</th>
              <th className="text-end">{amountHeaderLabel}</th>
            </tr>
          </thead>
          <tbody>
            {invoices.length === 0 ? (
              <tr>
                <td colSpan={4} className="invoice-selection-empty">
                  No invoices available for the selected quotation.
                </td>
              </tr>
            ) : (
              invoices.map((invoice) => {
                const isDisabled = Number(invoice.amount) <= 0;
                return (
                  <tr
                    key={invoice.selectionKey}
                    className={isDisabled ? "invoice-row-disabled" : ""}
                  >
                    <td>
                      <input
                        type="checkbox"
                        checked={selectedInvoiceIds.includes(invoice.selectionKey)}
                        disabled={isDisabled}
                        onChange={(event) =>
                          onToggleInvoice(invoice.selectionKey, event.target.checked)
                        }
                      />
                    </td>
                    <td>{invoice.invoiceId || "N/A"}</td>
                    <td>{invoice.description || invoice.quotationNumber || "N/A"}</td>
                    <td className="text-end">
                      {Number(invoice.amount || 0).toFixed(3)}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvoiceSelectionTable;
